import React from 'react'

const DownloadIcon = () => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width="15" height="14" viewBox="0 0 15 14" fill="none" className='me-2'>
<path d="M7.33162 8.99837L7.33162 0.665039M7.33162 8.99837C6.7481 8.99837 5.6579 7.33645 5.24829 6.91504M7.33162 8.99837C7.91515 8.99837 9.00535 7.33645 9.41496 6.91504" stroke="#616161" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
<path d="M13.9984 10.665C13.9984 12.7334 13.5667 13.165 11.4984 13.165H3.16504C1.09671 13.165 0.665039 12.7334 0.665039 10.665" stroke="#616161" strokeWidth="1.33" strokeLinecap="round" strokeLinejoin="round"/>
</svg>
  )
}

export default DownloadIcon